import React, { FC } from "react";
import { TextField, Spinner } from "@telia/teddy";
import _get from "lodash/get";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../../../../../models";
import { isTypeLoading } from "../../../../loading/state/selectors";
import { fetchPickupPoints } from "../../../../pickup-points/state/actions";
import * as PICK_UP_POINT_AT from "../../../../pickup-points/state/actionTypes";
import { setDeliveryZipCode } from "../../../state/actions/deliveryInfoActions";
import { getDeliveryInfoZipCode } from "../../../state/selectors/deliveryInfoSelectors";

interface StateProps {
    deliveryInfoZipCode?: string;
    isLoadingPickupPoints: boolean;
}

interface ConnectedPickupPointTextFieldProps extends StateProps {
    onPointSelected: (code: string | undefined, zipCode: string) => void;
}

const ConnectedPickupPointTextField: FC<ConnectedPickupPointTextFieldProps> = ({
    deliveryInfoZipCode,
    isLoadingPickupPoints,
    onPointSelected,
}) => {
    const dispatch = useDispatch();

    const handleOnChange: (value: string) => Promise<void> = async (value) => {
        const onlyDigits = (value || "").replace(/\D/g, "");
        const code = onlyDigits.substring(0, 4);
        dispatch(setDeliveryZipCode(code));

        if (code.length === 4 && code !== deliveryInfoZipCode) {
            const pickupPoints = await dispatch(fetchPickupPoints(code));
            const firstPoint = _get(pickupPoints, "points[0]");
            if (firstPoint?.code) {
                onPointSelected(firstPoint.code, code);
            }
        }
    };

    return (
        <TextField>
            <TextField.Label>Søk med postnummer</TextField.Label>
            <TextField.InputGroup>
                <TextField.Input
                    placeholder="F.eks 0010"
                    value={deliveryInfoZipCode}
                    onChange={async (event: React.ChangeEvent<HTMLInputElement>) =>
                        await handleOnChange(event.target.value)
                    }
                />
                {isLoadingPickupPoints && <Spinner size="sm" />}
            </TextField.InputGroup>
        </TextField>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    deliveryInfoZipCode: getDeliveryInfoZipCode(state),
    isLoadingPickupPoints: isTypeLoading(state, PICK_UP_POINT_AT.PICKUP_POINTS_FETCH_PICKUP_POINTS),
});

export default connect(mapStateToProps)(ConnectedPickupPointTextField);
